// @ts-nocheck
import { useEffect, useState, useCallback, useMemo } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  FormControl,
  Select,
  MenuItem,
  Box,
  ListItemText,
} from '@mui/material';
// components
import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
import SearchNotFound from '../components/SearchNotFound';
import { BookingListHead } from '../sections/@dashboard/bookings';
// mock
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { getAuthDetails } from '../store/state/authSlice';
import {
  useApproveCancelBookingByServiceProviderMutation,
  useGetAllBookingDetailBySearchCriteriaMutation,
} from '../store/api/bookingsApi';
import { getbookingSpaces, getBookingTotalRecords, setBookings } from '../store/state/bookingSlice';
import toast from 'react-hot-toast';
import Loading from '../components/Loading';
import { SelectDatepicker } from 'react-select-datepicker';
import React from 'react';
import { styled } from '@mui/material/styles';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'Date', label: 'Date', alignRight: false },
  { id: 'OccupancyatDayStart', label: 'Occupancy at Day Start', alignRight: false },
  { id: ' NoOfCheckins ', label: 'No Of Checkins', alignRight: false },
  { id: 'NoOfCheckouts ', label: ' No Of Checkouts', alignRight: false },
  { id: ' OccupancyatDayEnd ', label: 'Occupancy at Day End', alignRight: false },
  { id: '' },
];

const ResponsiveBox = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '20px',
  },
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },
}));

const ButtonBox = styled('div')(({ theme }) => ({
  padding: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    width: '275px',
    marginRight: '12px',
  },
}));

const variants = [
  {
    id: 3,
    name: 'Voucher',
    slug: 'voucher',
    type: 'Main',
    locale: 'en',
    created_at: '2021-11-15T08:27:23.000Z',
    updated_at: '2021-11-15T08:27:23.000Z',
    cover: null,
  },
  {
    id: 1,
    name: 'Top Up',
    slug: 'top-up',
    type: 'Main',
    locale: 'en',
    created_at: '2021-11-15T08:26:44.000Z',
    updated_at: '2021-11-15T08:26:44.000Z',
    cover: null,
  },
  {
    id: 2,
    name: 'Game Key',
    slug: 'game-key',
    type: 'Main',
    locale: 'en',
    created_at: '2021-11-15T08:27:03.000Z',
    updated_at: '2021-11-15T08:27:03.000Z',
    cover: null,
  },
  {
    id: 12,
    name: 'Other',
    slug: 'other',
    type: 'SubMain',
    locale: 'en',
    created_at: '2021-11-15T08:30:50.000Z',
    updated_at: '2021-11-15T08:30:50.000Z',
    cover: null,
  },
  {
    id: 11,
    name: 'Nintendo',
    slug: 'nintendo',
    type: 'SubMain',
    locale: 'en',
    created_at: '2021-11-15T08:30:22.000Z',
    updated_at: '2021-11-15T08:30:22.000Z',
    cover: null,
  },
  {
    id: 10,
    name: 'Xbox',
    slug: 'xbox',
    type: 'SubMain',
    locale: 'en',
    created_at: '2021-11-15T08:30:08.000Z',
    updated_at: '2021-11-15T08:30:08.000Z',
    cover: null,
  },
];
export default function Statistics() {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [getAllBookingDetailBySearchCriteria, getAllResponse] = useGetAllBookingDetailBySearchCriteriaMutation();
  const [approveCancelBookingByServiceProvider, vendorApproveResponse] =
    useApproveCancelBookingByServiceProviderMutation();
  const BookingData = useAppSelector(getbookingSpaces);
  const [cancellations, setAllCancellations] = useState();
  const token = JSON.parse(localStorage.getItem('login')) || null;
  const bookingTotalRecords = useAppSelector(getBookingTotalRecords);
  const dispatch = useAppDispatch();
  const [value, setValue] = useState<Date | null>(new Date());
  const onDateChange = useCallback((date: Date) => {
    setValue(date);
  }, []);

  const [variantName, setVariantName] = React.useState([
    {
      id: 11,
      name: 'Nintendo',
      slug: 'nintendo',
      type: 'SubMain',
      locale: 'en',
      created_at: '2021-11-15T08:30:22.000Z',
      updated_at: '2021-11-15T08:30:22.000Z',
      cover: null,
    },
    {
      id: 10,
      name: 'Xbox',
      slug: 'xbox',
      type: 'SubMain',
      locale: 'en',
      created_at: '2021-11-15T08:30:08.000Z',
      updated_at: '2021-11-15T08:30:08.000Z',
      cover: null,
    },
  ]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    let duplicateRemoved = [];
    value.forEach((item) => {
      if (duplicateRemoved.findIndex((o) => o.id === item.id) >= 0) {
        duplicateRemoved = duplicateRemoved.filter((x) => x.id === item.id);
      } else {
        duplicateRemoved.push(item);
      }
    });

    setVariantName(duplicateRemoved);
  };

  const getCancellationDetailsAsync = async (
    flag,
    offset,
    sortOrder,
    newPage,
    columnName,
    serviceProviderId,
    customerName
  ) => {
    await getAllBookingDetailBySearchCriteria({
      token: token.token,
      payload: {
        columnName: columnName,
        offset: offset,
        page: newPage,
        orderBy: sortOrder,
        flag: flag,
        customerName: customerName,
        serviceProviderId: serviceProviderId,
      },
    });
  };

  useEffect(() => {
    getCancellationDetailsAsync('CANCEL_BOOKING', rowsPerPage, orderBy, page, 'id', token.serviceProviderId, '');
  }, []);

  useEffect(() => {
    if (getAllResponse.isSuccess) {
      dispatch(setBookings(getAllResponse.data));
    }
  }, [getAllResponse.isSuccess]);

  useEffect(() => {
    if (BookingData) {
      setAllCancellations(BookingData);
    }
  }, [BookingData]);

  useEffect(() => {
    if (vendorApproveResponse.isSuccess) {
      getCancellationDetailsAsync('CANCEL_BOOKING', rowsPerPage, orderBy, page, 'id', token.serviceProviderId, '');
      toast.success('Cancellation approved');
    }
  }, [vendorApproveResponse.isSuccess]);

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = async (event, newPage) => {
    setPage(newPage);
    await getCancellationDetailsAsync(
      'CANCEL_BOOKING',
      rowsPerPage,
      orderBy,
      newPage,
      'id',
      token.serviceProviderId,
      ''
    );
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
    getCancellationDetailsAsync(
      'CANCEL_BOOKING',
      rowsPerPage,
      isAsc ? 'desc' : 'asc',
      0,
      'id',
      token.serviceProviderId,
      ''
    );
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    getCancellationDetailsAsync(
      'CANCEL_BOOKING',
      parseInt(event.target.value, 10),
      orderBy,
      0,
      'id',
      token.serviceProviderId,
      ''
    );
  };
  const filteredUsers = cancellations ? cancellations : [];
  const isUserNotFound = filteredUsers.length === 0;

  return (
    <Page title="Statistics">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Statistics
          </Typography>
        </Stack>

        <Card>
          <ResponsiveBox style={{ display: 'flex' }}>
            <Box style={{ marginLeft: '20px', marginTop: '33px' }}>
              <div>
                <FormControl>
                  <Select
                    labelId="demo-multiple-checkbox-label"
                    multiple
                    value={variantName}
                    onChange={handleChange}
                    renderValue={(selected) => selected.map((x) => x.name).join(', ')}
                    style={{ width: '250px', marginTop: '8px' }}
                  >
                    {variants.map((variant) => (
                      <MenuItem key={variant.id} value={variant}>
                        <Checkbox checked={variantName.findIndex((item) => item.id === variant.id) >= 0} />
                        <ListItemText primary={variant.name} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </Box>
            <Box>
              <SelectDatepicker selectedDate={value} onDateChange={onDateChange} order="month/year" hideLabels="true" />
            </Box>

            <ButtonBox style={{ marginLeft: '10px', marginTop: '35px' }}>
              <Stack>
                <Button
                  style={{
                    width: '100%',
                    borderColor: 'blue',
                    padding: '10px',
                    marginLeft: '10px',
                    alignItems: 'center',
                  }}
                  onClick={() => {
                    // handleSubmit();
                  }}
                  variant="contained"
                >
                  Submit
                </Button>
              </Stack>
            </ButtonBox>
          </ResponsiveBox>

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <BookingListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={cancellations?.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                />
                <TableBody>
                  {filteredUsers.map((row) => {
                    const {
                      id,
                      name,
                      bookingCode,
                      role,
                      status,
                      avatarUrl,
                      isVerified,
                      parkingSpaceLocationRespDTO,
                      parkingSlotRespDTO,
                      customerDetailResponseDTO,
                      parkingLocationId,
                      serviceProviderId,
                      customerId,
                      bookingAmount,
                      cancellationReasonName,
                    } = row;
                    const isItemSelected = selected.indexOf(name) !== -1;

                    return (
                      <TableRow
                        hover
                        key={id}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        {/* <TableCell align="left">{bookingCode}</TableCell>
                        <TableCell align="left">{customerDetailResponseDTO?.name}</TableCell>
                        <TableCell align="left">{parkingSpaceLocationRespDTO?.name}</TableCell>
                        <TableCell align="left">{bookingAmount}</TableCell>
                        <TableCell align="left">{cancellationReasonName}</TableCell>
                        <TableCell align="left">{isVerified ? 'Verified' : 'Not Verified'}</TableCell> */}
                      </TableRow>
                    );
                  })}
                </TableBody>

                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={12} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={bookingTotalRecords || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
      {getAllResponse.isLoading || vendorApproveResponse.isLoading ? <Loading /> : null}
    </Page>
  );
}
